import { Button } from '@/lib';
import { RouteConstants } from '@/features/router/RouteConstants';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type WaOnboardingBannerProps = {
  onboardingUrl?: string;
};

/**
 * Whatsapp Business is connected but no phone number is attached yet, so the template statuses
 * cannot exist. Sits where the load-error banner would: same shape, but it offers the activation
 * instead of a retry that cannot succeed.
 */
export const WaOnboardingBanner: FC<WaOnboardingBannerProps> = ({ onboardingUrl }) => {
  const { t } = useTranslation('comuni');
  const history = useHistory();

  return (
    <div className='flex flex-wrap items-center justify-between gap-3 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3'>
      <p className='text-sm text-sky-900'>{t('modelli.waNumberNotConfigured')}</p>
      {onboardingUrl ? (
        <Button
          intent='secondary'
          size='sm'
          text={t('modelli.waActivateNumber')}
          onClick={() => window.open(onboardingUrl, '_blank', 'noopener,noreferrer')}
        />
      ) : (
        // The link is minted at connection time and expires after five days; reconnecting from the
        // destinations page is what issues a new one.
        <Button intent='secondary' size='sm' text={t('modelli.waGoToDestinations')} onClick={() => history.push(RouteConstants.destinations)} />
      )}
    </div>
  );
};
